'use strict';

exports = module.exports = {

};



//////////////////
// WEBPACK FOOTER
// ./server/config/environment/shared.js
// module id = 168
// module chunks = 0